// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__3nnM7","body":"Main_body__1cTmp","nav":"Main_nav__Kao8r","navItem":"Main_navItem__37ZaX","active":"Main_active__1RpH5"};